import { Component, ViewChild, ElementRef } from '@angular/core'
import { InputBaseComponent } from '../input-base.component';
declare var $: any;
@Component({
  selector: 'ct-input-radio-group',
  templateUrl: './ct-input-radio-group.component.html',
  styleUrls: ['./ct-input-radio-group.component.css']
})


export class CtInputRadioGroupComponent extends InputBaseComponent {
  @ViewChild('el') formControl: ElementRef;
  public title: any;
  public data: any;
  constructor() {
    super();
  }

  ngAfterContentInit(): void {
    this.setProperties(this);
  }
  getTitle(): any { return this.title };
  
  getData(): any { return this.data };
  getFormControl(): any { return this.formControl }
  setData(data: any): void { this.data = data }
  setTitle(title: any): void { this.title = title }
}

